module.exports = __webpack_public_path__ + "static/media/road - complete.5511636e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/road - complete.svg
// module id = 172
// module chunks = 0